// extracted by mini-css-extract-plugin
module.exports = {"ctn":"nav_ctn___bgF-","box":"nav_box__3M9nm","item":"nav_item__3ugMs"};